import enLocale from 'element-ui/lib/locale/lang/en'
const en = {
	header: {
		home:"HOME",
		Classes:"COURSES",
		Camps:"CAMPS",
		private:"PRIVATE CLASSES",
		competition:"TOURNAMENTS",
		Community:"COMMUNITY",
		Calendar:"CALENDAR",
		Teachers:"TEACHERS",
		About:"ABOUT US",
		Cart:"CART",
		login:"LOGIN",
		success:"Completed",
		check:"Please select the course you want to enroll",
		FAQ:"FAQ",
		COURSES:"DASHBOARD",
		input:"input",
		select:"select",
		LOGOUT:"LOGOUT",
		confirm_delete:"Are you sure you want to exit?",
		confirm_del:"Are you sure you want to delete this?",
		del_success:"Deleted",
		tips:"Tips",
		resetPassword:"Your password has been reset",
		go_cart:"Go to Cart",
		continue:"Continue Shopping",
		upload_success:"Upload Successfully",
		activity:"ACTIVITIES",
		picture_preview:"Picture Preview",
		management:"Course",
	},
	index:{
		connection:'Connection Timeot,check your internet or retry later',
		no_data:"There's no data",
		promotion:'Promotions',
		roadmap:'Roadmap',
		learn:'Learning Centers',
		video:'Videos',
		awards:'Tournament Awards',
		news:'News',
		events:'Activities',
		user_name:'Username',
		password:'Password',
		p1:'Forgot password?',
		p2:'Enter your username or email address and we will send you a link to reset your password.',
		p3:'Reset Password',
		FORGOT:'FORGOT PASSWORD',
		RESET:'RESET PASSWORD',
		Back:'Back',
		categories:'Class Categories',
		enter:'Enter the class name here ...',
		view:'Search',
		logo_tips:'The current user cannot access this page. Please log in again',
		added_to_cart:"Added to cart",
		logo_tips1:"Please check virtual classroom for teacher's feedback and homework",
		logo_tips_buttom_ok:'Virtual Classroom Guide',
		logo_tips_buttom_cancel:'Cancel',
		logo_tips_buttom_classroom:'Enter Virtual Classroom',
	},
	footer:{
		FAQ:"FAQ",
		Terms:"Terms",
		Team:"Management Team",
		teacher_apply:"Career",
		Contact:"Contact",
		Copyright:"Copyright © 2024 Able2Shine.  All Rights Reserved.",
	},
	navleft:{
		dashboard:"Dashboard",
		course:"Course including Long Term Private",
		camp:"Camp",
		private:"One-Time Private Class",
		orders:"Orders",
		orders_camps:"Camp Orders",
		account:"Password",
		friend:"Refer a Friend",
		credits:"Tuition Credits",
		child:"Students Information",
		virtual:"Virtual Class",
		information:"Information Center",
		leave:"Absent Request",
		edit:"Setting",
		read:"All Read",
		coupon:"Coupon",
		receive:"Receive Coupon",
	},
	course:{
		type:'Type',
		Filter:'Filter',
		Search:'Search',
		Reset:'Reset',
		Search_bon:'Search',
		Age:'Age',
		Teacher:'Teacher',
		Season:'Session',
		Site:'Site',
		time:'Time',
		Class:'Class Day',
		tab_Teacher:'Teacher',
		tab_Name:'Subject',
		tab_Price:'Tuition',
		tab_Enroll:'Enroll',
		tab_session:'Session',
		tab_week:'Category',
		tab_cate:'Categories',
		tab_price:'Tuition',
		tab_center:'Site',
		tab_class_num:'Total Classes',
		tab_age:'Age',
		tab_date:'Date',
		tab_time:'Time',
		Add_Cart:'Add Selected To Cart',
		Filter_Age:'Filter by Age',
		Filter_Teacher:'Filter by Teacher',
		Filter_Class:'Filter by Class Day',
		learn_center:'Site',
		ClassSize:'Class Size',
		people:'Number of Students',
		lunch_price:'Lunch Fee',
		look_price:'Extended Care Fee',
		look_price1:'Extended Care Fee(AM)',
		look_price2:'Extended Care Fee(PM)',
		have_lunch:'Lunch',
		have_look:'Extended Care ',
		have_lunch1:'Lunch Needed',
		have_look1:'Extended Care Needed',
		Weeks:'Weeks',
		children:'Student',
		end_time:'End Time',
		private_course:'Private Course',
		selected_course:'Selected Course',
		selected_course1:'Total amount of selected courses:',
		activity_name:'Activity',
		activity_num:'Activity Size',
		image:'Image',
	},
	teacher_apply:{
		FirstName:'First Name',
		LastName:'Last Name',
		Email:'Email',
		Phone:'Cell Phone',
		Address:'Address',
		YouCanTeach:'Which courses can you teach?',
		teaching_experience:'Educational background and teaching experience.',
		style:'Please use 3 words to describe your teaching style.',
		resume:'Copy and paste your resume below.',
		rules_first_name:'Please enter your first name',
		rules_last_name:'Please enter your last name',
		rules_email:'Please enter your email address',
		rules_phone:'Please enter your Correct Email Address',
		rules_phone_:'Please enter your phone number',
		rules_course:'Please select the courses',
		rules_history:'Please tell us about your educational background and teaching experience.',
		Submit:'Submit',
		Evidence:'Upload pictures or videos that can show your teaching experience.',
		Select_Files:'Select Files',
		word_file:'Upload your resume file (WORD file or PDF file)',
	},
	course_info:{
		description:'DESCRIPTION',
		additional:'ADDITIONAL INFORMATION',
		reviews:'REVIEWS',
		friend:'REFERRER',
		Enroll:'Enroll Now',
		AddCart:'Add to Cart',
		Teacher:'Teacher',
		Date:'Date',
		Time:'Time',
		Site:'Site',
		Ages:'Ages',
		ClassDay:'Class Day',
		Theme:'Theme',
		Session:'Session',
		ClassSize:'Class Size',
		Address:'Address',
		ClassInfo:'Class Info',
		ClassHighlight:'Class Highlight',
		TeacherInformation:'Teacher Information',
		description_list:'You may be interested in',
		options:'More',
		click_copy:'Click “Copy” to get the invitation link.',
		click_copy_TokenId:'Please log in first',
		copy:'Copy',
		copy_success:'Copied',
		copy_error:'The browser does not support automatic copy.',
		no_course_dates:'No class on',
		class_num:'Total Classes',
		introduce:'Notes',
		early:'EarlyBird Time',
		competition_description:'Description',
		sign_up:'Sign Up',
		Date_time:'Date & Time',
        noon_price:'Noon Care Fee',
	},
	Teacher_index:{
		TeacherClasses:'Classes',
		name:'Meet Our Professional, \r\n Experienced & Caring Teachers',
		introduce:'We have a professional hiring and coaching team to find talented professionals and train them to teach according to Able2Shine standards. Our outstanding American teachers and coaching team help our students develop not only speaking and writing skills, but also encourage them to be authentic and self-loving. We also develop our own curriculum and integrate all community resources together.',
	},
	news:{
		More:'Read More',
		Posts:'Related Posts',
	},
	cart:{
		name:'My shopping cart',
		Teacher	:'Teacher',
		Program	:'Program',
		Student	:'Students',
		student	:'student',
		Price:'Price',
		Quantity:'Quantity',
		Total:'Total',
		Operation:'Action',
		Couponcode:'Coupon Code',
		Applycoupon:'Apply Coupon',
		Updatecart:'Update Cart',
		Carttotals:'Total',
		discounts:'Discounts',
		Subtotal:'Subtotal',
		Tax:'Tax',
		Continueshopping:'Continue Shopping',
		Proceedtocheckout:'Proceed to Checkout',
		please_choose:'Please select a student',
		subtotal_of_general_courses:'Course Order Subtotal',
		summer_camp_subtotal:'Camp Order Subtotal',
		private_camp_subtotal:'Subtotal of private teaching',
	},
	cart_settlement:{
		name:'My Order',
		order:'ORDER INFORMATION',
		select:'DISCOUNT',
		payment:'PAYMENT METHOD',
		amount:'ORDER AMOUNT',
		teacher:'Teacher:',
		program:'Program:',
		student:'Student:',
		price:'Price:',
		quantity:'Quantity:',
		total:'Total:',
		subtotal:'Subtotal',
		tax:'Tax',
		total_tab:'Total',
		payimmediately:'Pay Now',
		input_zhif:'Please select the payment method.',
		input_xinyemian:'Payment form will open in a new window.',
		payment_successful:'Payment Completed',
		payment_failed:'Payment Failed',
		integral:'POINTS',
		available_points:'Available Points',
		using_points:'Use Points',
		coupon_get:'Coupon collection',
		coupon_get_ma:'Please enter the coupon collection code',
		get_coupon:'Receive',
		entry_student:'Name Of Student',
		entry:'Contest Entry',
		your_video:'Name Of Your Video',
		video_link:'Video Link Submission',
		submit:'Order Now',
		student_information:'Student Information',
		student_name:'Student Name',
		wechatpay:'WechatPay',
		alipay:'Alipay',
	},
	member_child:{
		profile:'Profile Details',
		name:'Student ',
		name_child:'Name',
		year:'Date of Birth',
		add:'Add a Student',
		confirm:'Save',
	},
	member_account:{
		select:'Select Time Zone',
		account:'Change Password',
		confirm:'Save',
		country:'Country',
		timezone:'Time Zone',
		username:'Username',
		email:'Email Address',
		old_password:'Old Password',
		new_password:'New Password',
		confirm_password:'Confirm Password',
		rules_old:'Please enter the old password',
		rules_new:'Please enter a new password',
		rules_confirm:'inconsistent passwords',
		name:'Name',
		tel:'Tel',
		wechat_id:'WeChat name',
		province:'State/Province',
	},
	member_orders:{
		paid:'Paid',
		topaid:'To be Paid',
		completed:'Completed',
		course:'Course Name',
		teacher:'Teacher',
		student:'Student',
		original:'Original Price',
		discounts:'Discounts or Credits',
		score:'Points',
		quantity:'Quantity',
		total:'Total',
		paiddate:'Payment Date',
		operation:'Action',
		subtotal:'Subtotal',
		tax:'Tax',
		total_tab:'Total',
		carttotals:'Total',
		checkout:'Proceed to Checkout',
		order_id:'Order No.',
		View:'View Details',
		refunded:'Refunded',
		payment_method:'Payment Method',
	},
	member_courses:{
		current:'Current',
		future:'Future',
		finish:'Finish',
		syllabus:'Class Name',
		teacher:'Teacher',
		date:'Date',
		course:'Class Number',
		virtual:'Virtual Class',
		get_into:'Enter',
		download:'Download',
	},
	member_virtual:{
		entering:'Enter Class',
		admin:'Contact Admin',
		teacher:'Contact Teacher',
		syllubus:'Syllabus',
		course_form:'Course Evaluation Form',
		download:'Download Syllabus',
		curriculum:'Curriculum',
		date:'Date',
		comment:'Comment',
		view:'View',
		zoom:'Zoom Link',
		center_name:'Site',
	},
	teachers_virtual:{
		in_class:'In Class',
		finish:'Finish',
		entering:'Enter Class',
		Course:'Course Evaluation Form',
	},
	teachers_leave:{
		start:'Start date',
		end:'End date',
		range:'to',
		time:'Time off',
		reason:'Reason',
	},
	member_index:{
		form:'Class List',
		calendar:'Calendar',
		syllabus:'Class Name',
		teacher:'Teacher',
		date:'Date',
		course:'Class Number',
		content:'Content',
		points:'Points',
	},
	index_register:{
		login_user_name:'Student Account',
		h1:"Please fill in the following fields to create a new account. ",
		time_zone:"Select Time Zone",
		country:"Country",
		Timezone:"Time Zone",
		information:"Other Information ",
		address:"Referrer’s Email Address",
		names:"Sales Associate’s Name",
		account:"Account Details",
		username:"Username",
		email:"Email Address",
		email_:"Correct Email Address",
		password:"Choose a Password",
		confirm_password:"Confirm Password",
		profile:"Profile Details",
		name:"Parent's Name ( First Name + Last Name )",
		namekid:"Student",
		namekid_:"Information",
		yearmonth:"Date of Birth",
		addchild:"Add Another Student",
		phone:"Phone Number",
		wechat:"WeChat name",
		wechat_text:"If you don't have, please put N/A",
		city:"City & State(or province)",
		complete:"Create",
		thetwo:"Inconsistent Passwords",
		successful:"Logged In Successfully",
		perfect:"Please complete the information",
		code:"SMS verification code",
		code_email:"Email verification code",
		phone_code:"Send verification code",
		Sent_successfully:"Sent Successfully",
		wrong_password:"Wrong Password",
		unlocking:"Unlock",
		adult:"Is the student an adult?",
		inactive:"No",
		active:"Yes",
		user_name:"User Name",
		password:"Password",
		grade:"Grade",
		student_name:"Student's Name ( First Name + Last Name )",
		student_email:"Student's Email",
		expired:"Expired! Please pick the current camps/classes.",
		expired1:"This week's camp has started. Please confirm you want to join.",
	},
	index_login:{
		h1:'Sign in to continue',
		h2:'Not a member yet? ',
		h3:'Register now',
		h4:'Teacher login',
		username:'Username',
		password:'Password',
		login:'Login Now',
		forgot:'Forgot Password',
		select:'Please Select',
		password_login:'Password Login',
		code_login:'Verification Code Login',
		tel:'Tel',
		code:'Code',
	},
	member_friend:{
		p1:"Please register to get your referral link.",
		email:"Your Email",
		generate:"Generate",
	},
	payment:{
		tips:'Order completed.  View order or return to home page.',
		order:'Order',
		index:'Home',
		alipay:'Please complete the payment in the new page',
		cart:'Payment failed and returned to shopping cart',
		order_info:'Payment successful View order',
		qrcode:'Please use WeChat to scan and complete the payment',
	},
	virtual:{
		list:'Class No.',
		mail:'Internal Message',
		teacher_news:'Chat with Teacher',
		comment:'Comment',
		comment_history:'Comment history',
		task:'Task',
		hair_task:'Homework',
		upload_task:'Turn in Assignment',
		upload_task_:'Homework Turned in',
		batch_task:'Batch operation',
		course_assess:'Class Evaluation',
		course_assess_history:'Class Evaluation history',
		certificate:'Certificate',
		feedback:'Feedback',
		feedback_history:'Feedback history',
		on:'No.',
		time:'Time',
		course:'Course',
		status:'Status',
		leave:'Absent Request',
		signin:'Sign In',
		course_name:'Course Name',
		teacher_name:"Teacher’s Name",
		course_time:'Course Time',
		course_status:'Course Status',
		leave_history:'Absent Record',
		del:'Delete',
		edit:'Edit',
		return:'Return',
		all:'All',
		unread:'Unread',
		read:'Read',
		unread_quantity:'Unread Messages',
		teachers_index:'Roll Call',
		teachers_index_history:'Roll Call history',
		teachers_task:'Task',
		teachers_parent:'Communication',
		teachers_letter:'Letter',
		teachers_letter_history:'Letter history',
		teachers_assess:'Course Assessment?',
		teachers_certificate:'Certificate',
		teachers_leave:'Absence',
		operation:'Action',
		select:'Select',
		student:'Student',
		parent:'Parent',
		submit:'Submit',
		class_size:'Class Size',
		course_today:"Today's course",
		arrived_num:'Number of Students Attended',
		not_arrived_num:'Number of Students Absent',
		name:'Name',
		content:'Content',
		file_upload:'Upload File',
		add_file:'Add File',
		file:'File',
		upload:'Upload',
		download:'Download',
		time:'Time',
		reason:'Reason',
		content_work:'Correct Content',
		letter_type:'Type',
		children_id:'Choose students',
		send:'Send',
		score:'Score',
		assessment:'Assessment',
		issue_certificate:'Issue Certificate',
		remarks:'Remarks',
		upload_video:'Upload File(FileSize < 20MB)',
		upload_link:'File Link(FileSize > 20MB)',
		ok:'OK',
		cancel:'Cancel',
		student_name:'Student Name',
		p_tishi:'*Upload File(FileSize < 20MB) or Use File Link',
		view_job:'Check Homework',
		task_off:"The teacher hasn't left homework yet.",
		admin:'Contact Our Admin',
		comments:'Comments for the Teacher',
		certificate_img:'Long press to save the picture',
		debate:'Debate Evaluation',
	},
	footer_contact:{
		name:'Your Name',
		email:'Your Email',
		tel:'Your Tel',
		code:'Verification code',
		content:'Type in your feedback here.',
		title:"I can't see the next one clearly.",
		submit:'Submit',
		success:'Feedback Submitted Successfully',
	},
	assess:{
		title:'Listening, Speaking, Reading & Writing / Comprehensive Programs for Empowering Youth Confidence & Leadership / Lights, Camera, Action!',
		student:"Student's name",
		teacher:"Teacher's name",
		class:'Class Level',
		location:'Class Location',
		time:'Class Day & Time',
		session:'Session',
		notes:"Teacher's Notes",
		sound:'Teacher Recording',
	},
	member_coupon:{
		name:'Coupon Name',
		condition:'Service Conditions',
		discount:'Amount \r\n Discount',
		superposition:'Superposition',
		date:'term of Validity',
		frequency:'Usage Times',
		range:'Scope of use',
		look_up:'Look Up',
		code:'Receiving Code',
		cancel:'Cancel',
		submit:'Receive',
		success:'Receive Success',
		range_unlimited:'Unlimited scope of use',
		explain:'Instructions',
	},
	...enLocale
}
export default en;


// WEBPACK FOOTER //
// ./src/i18n/langs/en.js